import {
    UiStack,
    UiText,
} from '@experiences/ui-common';
import { ApLink } from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import urljoin from 'url-join';

import { routePaths } from '../../common/constants/routePaths';
import { accountLogicalName } from '../../store/selectors';

export const DownloadCenterSidebarLinkContainer = () => {
    const { formatMessage: translate } = useIntl();
    const accountName = useSelector(accountLogicalName);

    return <UiStack
        direction='column'
        key="link-item-download-center">
        <UiText data-cy="link-titleText-download-center">
            {translate({ id: 'CLIENT_LOOKING_FOR_DESKTOP_PRODUCTS' })}
        </UiText>
        <UiStack data-cy="link-linkText-download-center">
            <ApLink
                data-cy="link-anchor-download-center"
                href={urljoin(
                    origin,
                    accountName,
                    'portal_',
                    routePaths.resourceCenter)}
            >
                {translate({ id: 'CLIENT_DOWNLOAD_CENTER' })}
            </ApLink>
        </UiStack>
    </UiStack>;
};
